import React from "react";
import "assets/styles/myprofile/style.css";
import { CardProvider } from "context/CardContext";
import MainContent from "components/birthday";

const Card = (props) => {
  return (
    <CardProvider>
      <MainContent />
    </CardProvider>
  );
};

export default Card;
